import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'

interface Props {
  slice: any
  context: any
}

const ProductImages = ({ slice, context }: Props) => {
  const leftImage = context?.images?.[2]
  const rightImage = context?.images?.[3]
  if (!leftImage || !rightImage) return <></>
  return (
    <>
      {slice && (
        <div className="w-full bg-brand-light-grey ">
          <div className="wrapper flex flex-wrap pt-14 md:flex-nowrap">
            {leftImage?.url && (
              <div className="mb-2 block md:mr-4 md:inline-block lg:min-h-full">
                <div className="block md:inline-block lg:min-h-full">
                  <div>
                    <Image
                      src={leftImage?.url}
                      alt={leftImage?.altText || config.openGraph.images[0].alt}
                      width={'819'}
                      height={'614'}
                      objectFit="cover"
                    />
                  </div>
                  {leftImage?.altText && (
                    <div className="text-body2 text-brand-dark-grey">
                      {leftImage?.altText}
                    </div>
                  )}
                </div>
              </div>
            )}
            {rightImage && (
              <div className="block md:inline-block lg:min-h-full">
                <div>
                  <Image
                    src={rightImage?.url}
                    alt={rightImage?.altText || config.openGraph.images[0].alt}
                    width={'461'}
                    height={'614'}
                    objectFit="cover"
                  />
                </div>
                {rightImage?.altText && (
                  <div className="text-body2 text-brand-dark-grey">
                    {rightImage?.altText}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default ProductImages
